<template>
	<div class="case">
		<div class="comtop">
			<img src="../../static/img/casetoop.jpg"/>
		</div>
		
		<div class="case-nav">
			
		</div>
		<div class="com-detail">
			<div class="com-top-top">
					<ul>
						<li v-for="navli in navli" class="casenav" v-bind:class="{caseacli : lijudge == navli.Tabtit}" @click="seltab(navli.Tabtit)">{{navli.Tabtit}}</li>
					</ul>
			</div>
			<!--
            	描述：公司简介
           -->
            <div class="caseinfo">
				<div class="sel-tab" >
					<!--服务事业-->
					<div class="caseone">
						<div class="casetab" v-for="pro in tableData" v-if="lijudge == pro.proremark">
							<div class="tab-contents">
								<div class="t-c-left">
									<b>{{pro.protit}}</b>
									<p>{{pro.procontent}}
									</p>
									<el-button type="csces" @click = "tohonme(pro.id)">Read more +</el-button>
								</div>
								<div class="t-c-right">
									<img :src="pro.propic"/>
								</div>
							</div>
							
						</div>
						
					</div>
					
					
					
				</div>
            </div>
            
		</div>
	</div>
</template>

<script>
	export default{
		name : 'case',
		data(){
			return {
				chalid : 0,
				navli : [
				],
				tableData : [],
				scrollWatch: true,
				lijudge : '工厂厂房',
				selid : 0
			}
		},
		mounted(){
			this.getID();
			this.getnews();
		},
		methods : {
			getID(){
				this.chalid = this.$route.params.ID
			},
			getnews(){
      			var that = this;
      			var nowtable = this.tab;
      			var conlist = [];
      			var taball = [];
     				this.$http.post('http://www.gd-sc.net:9094',{table : 'protools'},{emulateJSON: true}).then((response) => {
     				for(var i =0 ; i < response.body.recordset.length ; i++){
     					response.body.recordset[i].propic = response.body.recordset[i].propic.replace(/src="/ , '')
     					response.body.recordset[i].propic = response.body.recordset[i].propic.replace(/"/ , '')
     					var info = response.body.recordset[i].procontent;
     					info = info.replace(/(\n)/g, "");    
				        info = info.replace(/(\t)/g, "");    
				        info = info.replace(/(\r)/g, "");    
				        info = info.replace(/<\/?[^>]*>/g, "");    
				        info = info.replace(/\s*/g, ""); 
				        info = info.replace(/&nbsp;/g, ""); 
				        response.body.recordset[i].procontent = info;
     				}
			        this.tableData = response.body.recordset;
			        
			      })
     				this.$http.post('http://www.gd-sc.net:9094',{table : 'Tabtit'},{emulateJSON: true}).then((response) => {
			        for(var i = 0; i<response.body.recordset.length ; i++){
			        	if(response.body.recordset[i].Remark == 'Tabtitp'){
			        		taball.push(response.body.recordset[i])
			        	}
			        }
			        this.lijudge = taball[0].Tabtit;
			        this.navli = taball;
			      })
     			},
			seltab(index){
				this.lijudge = index
			},
		tohonme : function(index){
  		this.$router.push('/Engineerings/'+index)
  		this.gotop()
  	}
		},
	}
</script>

<style>
	.aboutcom{
		position: relative;
		clear: both;
		width: 100%;
		margin: 0 auto;
	}
	.comtop{
		position: relative;
		width: 100%;
		clear: both;
	}
	.comtop img{
		width: 100%;
	}
	.com-tit{
		width: 40%;
		position: absolute;
		clear: both;
		z-index: 3;
		top: 12vw;
	    left: 11vw;
	    text-align: left;
	    font-size: 22px;
	    color: #fff;
	}
	.com-tit img {
	    width: 4%;
	    margin-right: 23px;
	}
	.com-tit p{
		margin-top: 20px;
		font-size: 14px;
		line-height: 28px;
	}
	.com-tit b{
		font-size: 25px;
	    position: relative;
	    top: 3px;
	}
	.case .com-detail{
		width: 80%;
		margin: 27px auto;
		position: relative;
		clear: both;
		text-align: left;
	}
	.com-detail h4{
		font-weight: 700;
		margin-left: 50px;
		font-size: 22px;
	}
	.com-line{
		width: 25px;
		height: 3px;
		position: absolute;
		background: #1975f0;
		border-radius: 4px;
		top: 8px;
	}
	.case .com-top-top{
		width: 100%;
		position: relative;
		padding-bottom: 10px;
		margin-bottom: 20px;
		border-bottom: none;
	}
	.com-top-top li.casenav{
		display: inline-block;
		width: 12%;
		padding: 10px;
		margin-right: 2px;
		color: #666;
		transition: .2s all;
	}
	
	.com-top-top li.casenav:hover{
	    transform: scale(1.05);
	    background: #f1c2c2 !important;
	    color: #da251c !important;
	}
	
	.com-top-top li.caseacli{
		color: #fff;
    	background: #da251c;
	}
	.case .com-top-top ul{
		width: 100%;
		margin: 0 auto;
		text-align: center;
	}
	.case-nav{
		position: absolute;
		width: 100%;
		background: #f7f7f7;
		height: 90px;
		border-bottom: 1px solid #ddd;
		border-top: 1px solid #ddd;
	}
	
	.com-detail h4.small-tit{
		text-align: center;
		width: 500px;
		margin: 0 auto;
		position: relative;
		color: #0066ef ;
		font-weight: 500;
	}
	.caseinfo{
		position: relative;
		clear: both;
		padding: 2%;
	}
	.caseinfo p{
		color: #666666;
		line-height: 26px;
		margin: 30px auto;
		font-size: 14px;
		text-indent:2em;
		height: 82px;
    	overflow: hidden;
	}
	.caseinfo img{
		text-align: center;
	}
	.imgcomab{
		width: 49%;
		position: relative;
		clear: both;
		display: inline-block;
		vertical-align: top;
		text-align: center;
	}
	.imgcomab img{
		width: 85%;
	}
	.singleimg,.singlewimg{
		width:100%;
		position: relative;
		margin: 0 auto;
		text-align: center;
	}
	.singleimg img{
		width: 75%;
	}
	.singlewimg img{
		width: 100%;
	}
	.comwenhua h3{
		color: #e03500;
		font-weight: 900;
		font-size: 22px;
	}
	.comwenhua p{
		text-indent:.5em;
	}
	.comwenhua span{
		color: #e03500;
	}
	.comwenhua{
		position: relative;
		margin-top: 45px;	
	}
	.caseone{
		position: relative;
		clear: both;
		margin: 0 auto;
		width: 100%;
	}
	.caseone h2{
		color: #e03500;
		font-size: 26px;
		font-weight: 600;
		margin-bottom: 20px;
	}
	.caseone b{
		color: #909090;
	}
	.tab-contents{
		width: 100%;
		position: relative;
		clear: both;
		margin: 30 auto;
		text-align: left;
	}
	.t-c-left{
		width: 68%;
		position: relative;
		clear: both;
		display: inline-block;
	}
	.t-c-right{
		position: relative;
		display: inline-block;
		vertical-align: top;
		float: left;
		margin-right: 30px;
		width: 28%;
	}
	.t-c-left b{
		font-size:16px;
		color: #666;
		border-bottom: 1px dotted #ccc;
    	padding: 0px 0px 15px 0px;
    	margin-bottom: 10px;
    	display: block;
	}
	.t-c-left p{
		margin: 15px auto ;
	}
	.t-c-right img{
		width: 90%;
		max-height: 200px;
	}
	.casetab {
	    position: relative;
	    margin-top: 30px;
    margin-right: auto;
    margin-bottom: 50px;
    margin-left: auto;
	    height: 196px;
	}
	.el-button--cases {
    color: #666;
    background-color: none;
    border: none !important;
    margin-top: 10px;
}
.el-button {
	margin-top: 10px;
}
.el-button:focus, .el-button:hover {
   color: #da251c !important;
    border-color: #ff8f89 !important;
    background-color: #ffe7e6 !important;
}
</style>


// WEBPACK FOOTER //
// src/components/engineering.vue